/**
 * LandingPage — Landing pública de turismo.nara.chat
 *
 * Sirve el HTML de la presentación comercial (public/landing.html) que
 * comparte diseño 1:1 con el PDF comercial en /docs/comercial/.
 * Para editar la landing modificar directamente public/landing.html.
 *
 * Rutas:
 *   /       → esta landing (redirige al HTML estático)
 *   /login  → app operativa
 *
 * Backup del landing anterior (React con 15 componentes): LandingPage.old.js.bak
 */
import React, { useEffect } from 'react';

export default function LandingPage() {
  useEffect(() => {
    // Reemplaza el URL actual con el HTML estático de la landing.
    //   - El navegador carga el HTML puro (con su propio CSS/JS)
    //   - No queda "/" en el historial (back button funciona)
    //   - React ya no controla esta vista
    window.location.replace('/landing.html');
  }, []);

  // Fallback breve mientras se redirige
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0fdfa',
      color: '#164e63',
      fontFamily: '-apple-system, "Segoe UI", sans-serif',
      fontSize: 14,
    }}>
      Cargando NARA Turismo…
    </div>
  );
}
